import type { ResultOf } from "@graphql-typed-document-node/core";
import { graphql } from "../gql";

// Data query

export const query = graphql(`
    query AppSelectPathQuery {
        currentPerson {
            id
            avatar
            user { pulseRights }
            ongoingPaths: learningPaths(filter: "ongoing") { id pathname }
            teamScans { id }
            standaloneAiChatbots { id }
        }
    }
`);

export type IData = ResultOf<typeof query>;

// Select mutation

export type ToolType = "path" | "teamScan" | "standaloneAiChatbot" | "pulse" | "profile";

export const selectMutation = graphql(`
    mutation AppSelectPathSelectMutation($tool: SelectPathToolType!, $pathId: String) {
        currentPersonSelectPath(tool: $tool, pathId: $pathId) {
            currentPerson { id }
            redirect
        }
    }
`);
